import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ValidatorForm } from "react-material-ui-form-validator";
import axios from "../../../../axios-order";
import MenuItem from "@mui/material/MenuItem";
import Modal from "react-bootstrap/Modal";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import CircularProgress from "@material-ui/core/CircularProgress";
import ReplayCircleFilledIcon from "@mui/icons-material/ReplayCircleFilled";
import RefreshIcon from "@mui/icons-material/Refresh";
import Tooltip from "@mui/material/Tooltip";
import { LoadingButton } from "@mui/lab";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import excelIconImage from "../../../../asserts/images/excelicon.svg";
import { canRead, canWrite } from "../../../../utils/privilegeUtils";

// ── Design tokens ─────────────────────────────────────────────────────────────
const C = {
    navy:        "#1a3f6f",
    accent:      "#1a6fc4",
    accentLight: "#e8f1fb",
    white:       "#ffffff",
    surface:     "#f7f9fc",
    border:      "#dde3ec",
    borderLight: "#eef1f6",
    text:        "#1a3f6f",
    textSub:     "#4a6080",
    textMuted:   "#8298b2",
    success: { bg: "#edf8f1", text: "#1a6e3e", dot: "#28a55f" },
    warning: { bg: "#fff8e6", text: "#7a4e00", dot: "#f0a500" },
    error:   { bg: "#fef2f2", text: "#991b1b", dot: "#ef4444" },
};

const Quter = [
    { id: "quarter1", value: "Quarter 1 Apr-Jun" },
    { id: "quarter2", value: "Quarter 2 Jul-Sep" },
    { id: "quarter3", value: "Quarter 3 Oct-Dec" },
    { id: "quarter4", value: "Quarter 4 Jan-Mar" },
];

const month = [
    { id: "01", value: "January"  },
    { id: "02", value: "February" },
    { id: "03", value: "March"    },
    { id: "04", value: "April"    },
    { id: "05", value: "May"      },
    { id: "06", value: "June"     },
    { id: "07", value: "July"     },
    { id: "08", value: "August"   },
    { id: "09", value: "September"},
    { id: "10", value: "October"  },
    { id: "11", value: "November" },
    { id: "12", value: "December" },
];

const BootstrapInput = styled(InputBase)(({ theme }) => ({
    "label + &": { marginTop: theme.spacing(3) },
    "& .MuiInputBase-input": {
        borderRadius: 4, position: "relative",
        backgroundColor: theme.palette.background.paper,
        border: "1px solid #ced4da", fontSize: 14,
        padding: "8px 26px 8px 12px",
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        "&:focus": { borderRadius: 4, borderColor: "rgba(0,123,255)" },
    },
}));

function formatDateTime(dt) {
    if (!dt) return "—";
    const cleaned = dt.replace("Z", "");
    const parts = cleaned.includes("T") ? cleaned.split("T") : cleaned.split(" ");
    const date = parts[0]; const time = parts[1] || "";
    return (
        <span>
            <span style={{ color: C.text, fontWeight: "500" }}>{date}</span>
            {time && <span style={{ color: C.textMuted }}> · {time}</span>}
        </span>
    );
}

const DocIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={C.accent} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="9" y1="13" x2="15" y2="13" />
        <line x1="9" y1="17" x2="13" y2="17" />
    </svg>
);

// ── Component ─────────────────────────────────────────────────────────────────
export default function GSTComputationReport() {
    const [trigarLoader,              setTrigarLoader]              = useState(false);
    const [trigarForErrorMessage,     setTrigarForErrorMessage]     = useState(false);
    const [tdsHistoryTable]                                         = useState(true);
    const [triggerButton]                                           = useState(true);
    const [triggerModelFromToDate,    setTriggerModelFromToDate]    = useState(false);
    const [tdsReconHistoryData,       setTdsReconHistoryData]       = useState([]);
    const [loaderForTable,            setLoaderForTable]            = useState(false);
    const [snackbarOpen,              setSnackbarOpen]              = useState(false);
    const [snackbarSeverity,          setSnackbarSeverity]          = useState("");
    const [message]                                                 = useState("");
    const [responseMessage,           setResponseMessage]           = useState("");
    const [yearFromArr,               setFromYearArr]               = useState([]);
    const [year,                      setYear]                      = useState("");
    const [quarter,                   setQuarter]                   = useState(null);
    const [period,                    setPeriod]                    = useState(null);
    const [errorMessage,              setErrMessage]                = useState(null);
    const [reportGennerationLoading,  setReportGenerationLoading]   = useState(false);
    const [hoveredRow,                setHoveredRow]                = useState(null);

    const history = useHistory();

    // ── Snackbar ──────────────────────────────────────────────────────────────
    const handleSnackbarOpen = (message, severity) => {
        setSnackbarSeverity(severity);
        setResponseMessage(message);
        setSnackbarOpen(true);
    };
    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
        setResponseMessage("");
    };

    const handleBack = () => history.push("/reportCards");

    // ── Year list ─────────────────────────────────────────────────────────────
    const setFromYearValues = () => {
        let current_year = new Date().getFullYear();
        let yearArr = [];
        for (let i = current_year - 10; i <= current_year + 10; i++) {
            let endYearShort = (i + 1).toString().slice(-2);
            yearArr.push({ id: i, year: `${i}-${endYearShort}` });
        }
        setFromYearArr(yearArr);
    };

    // ── Data fetch ────────────────────────────────────────────────────────────
    const getTdsPayableRecon = () => {
        setLoaderForTable(true);
        axios
            .get(`/get_gst_computation_summary/${localStorage.getItem("business_entity_id")}`)
            .then((res) => {
                setLoaderForTable(false);
                const records = res?.data?.records.map((record) => ({
                    ...record, excel_loading: false, regenerateLoading: false,
                }));
                setTdsReconHistoryData(records);
            })
            .catch(() => setLoaderForTable(false));
    };

    useEffect(() => { getTdsPayableRecon(); setFromYearValues(); }, []);

    // ── Modal close ───────────────────────────────────────────────────────────
    const handleOpenAndCloseModel = () => {
        setTriggerModelFromToDate(false);
        setTrigarLoader(false);
        setTrigarForErrorMessage(false);
        setYear(""); setQuarter(""); setPeriod(null);
    };

    // ── Submit ────────────────────────────────────────────────────────────────
    const onSubmitHandlerForData = () => {
        if (!year) { setTrigarForErrorMessage(true); setErrMessage("Financial Year is required!"); return; }
        setReportGenerationLoading(true);
        const payLoadData = {
            business_entity_id: localStorage.getItem("business_entity_id"),
            financial_year: year, quarter, period,
            org_gstin: localStorage.getItem("gst"),
        };
        axios.post("/create_gst_computation_report", payLoadData)
            .then((res) => {
                handleSnackbarOpen(res.data.message, res.data.status ? "success" : "error");
                getTdsPayableRecon(); handleOpenAndCloseModel();
            })
            .catch((err) => { getTdsPayableRecon(); handleOpenAndCloseModel(); handleSnackbarOpen(err?.data?.message, "error"); })
            .finally(() => setReportGenerationLoading(false));
    };

    // ── Helpers ───────────────────────────────────────────────────────────────
    const downloadBase64File = (contentType, base64Data, fileName) => {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource; downloadLink.download = fileName; downloadLink.click();
    };

    const updateReportGenerationStatus = (item) => {
        axios.post("/update_report_generation_status", item).then(() => getTdsPayableRecon()).catch(() => {});
    };

    const regenerateGstComputationReport = (item) => {
        setTdsReconHistoryData((prev) => prev.map((r) => r.id === item.id ? { ...r, regenerateLoading: true } : r));
        axios.post("/regenerate_gst_computation_report", { ...item, org_gstin: localStorage.getItem("gst") })
            .then((res) => {
                handleSnackbarOpen(res.data.message, res.data.status ? "success" : "error");
                getTdsPayableRecon(); handleOpenAndCloseModel();
            })
            .catch(() => {})
            .finally(() => setTdsReconHistoryData((prev) => prev.map((r) => r.id === item.id ? { ...r, regenerateLoading: false } : r)));
    };

    const handleExportExcel = (item) => {
        setTdsReconHistoryData((prev) => prev.map((r) => r.id === item.id ? { ...r, excel_loading: true } : r));
        const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        axios.post("/computation_excel_report", { summary_id: item.id, business_entity_id: localStorage.getItem("business_entity_id") })
            .then((res) => { downloadBase64File(contentType, res?.data?.file, "GST Computation Report.xlsx"); updateReportGenerationStatus(item); })
            .catch(() => {})
            .finally(() => setTdsReconHistoryData((prev) => prev.map((r) => r.id === item.id ? { ...r, excel_loading: false } : r)));
    };

    const updatedShowDetails = (item) => {
        if (item.report_status === "Generated") {
            history.push({
                pathname: `/gst_computation_report_data/${item.id}`,
                state: { items: item, financial_year: item.financial_year, period: `${item.from_month}-${item.to_month}` },
            });
            localStorage.setItem("is_confirm", item.is_confirm);
        } else {
            handleSnackbarOpen(item.fail_reason, "error");
        }
    };

    const handleLockToggle = (id, is_locked) => {
        setTdsReconHistoryData((prev) => prev.map((item) => item.id === id ? { ...item, is_locked: !is_locked } : item));
        axios.post("/update_computation_report_lock_status", {
            business_entity_id: localStorage.getItem("business_entity_id"), id, is_locked: !is_locked,
        })
            .then((res) => { if (res?.data?.status) handleSnackbarOpen(res?.data?.message, "success"); })
            .catch((error) => console.error("Error updating lock status:", error));
    };

    const handleTDSREconciliationButtonEvent = () => setTriggerModelFromToDate(true);

    // ── Status badge ──────────────────────────────────────────────────────────
    const StatusBadge = ({ status }) => {
        const scheme = status === "Generated" ? C.success : status === "Fail" ? C.error : C.warning;
        return (
            <span style={{ display: "inline-flex", alignItems: "center", gap: "5px", padding: "3px 10px", borderRadius: "5px", fontSize: "11px", fontWeight: "600", background: scheme.bg, color: scheme.text }}>
                <span style={{ width: "6px", height: "6px", borderRadius: "50%", background: scheme.dot, flexShrink: 0 }} />
                {status || "—"}
            </span>
        );
    };

    // ── Styles ────────────────────────────────────────────────────────────────
    const thStyle = {
        padding: "11px 18px", textAlign: "left", fontSize: "11px", fontWeight: "600",
        letterSpacing: "0.05em", color: "#ffffff", background: C.navy,
        borderBottom: "1px solid #16355c", textTransform: "uppercase", whiteSpace: "nowrap",
    };
    const tdStyle = {
        padding: "8px 18px", fontSize: "13px", color: C.text,
        borderBottom: `1px solid ${C.borderLight}`,
    };
    const labelStyle = {
        fontSize: "12px", fontWeight: "600", color: C.textSub,
        marginBottom: "6px", display: "block",
        textTransform: "uppercase", letterSpacing: "0.05em",
    };

    // ── Table body ────────────────────────────────────────────────────────────
    const renderTableBody = () => {
        if (loaderForTable) {
            return Array.from({ length: 3 }).map((_, i) => (
                <tr key={i}>
                    {[15, 20, 25, 15, 15].map((w, j) => (
                        <td key={j} style={tdStyle}>
                            <div style={{ height: "14px", borderRadius: "4px", background: C.borderLight, width: `${w}%`, animation: "pulse 1.4s ease-in-out infinite" }} />
                        </td>
                    ))}
                </tr>
            ));
        }
        if (!tdsReconHistoryData || tdsReconHistoryData.length === 0) {
            return (
                <tr>
                    <td colSpan={5} style={{ ...tdStyle, textAlign: "center", padding: "52px 20px" }}>
                        <div style={{ fontSize: "28px", marginBottom: "10px", opacity: 0.4 }}>📄</div>
                        <div style={{ fontWeight: "500", marginBottom: "4px", color: C.textSub }}>No reports found</div>
                        <div style={{ fontSize: "12px", color: C.textMuted }}>Generate your first GST Computation report to get started.</div>
                    </td>
                </tr>
            );
        }
        return tdsReconHistoryData.map((item, i) => (
            <tr
                key={i}
                onMouseEnter={() => setHoveredRow(i)}
                onMouseLeave={() => setHoveredRow(null)}
                style={{ background: hoveredRow === i ? C.surface : C.white, transition: "background 0.1s" }}
            >
                <td style={tdStyle}><span style={{ fontWeight: "600" }}>{item.financial_year}</span></td>
                <td style={tdStyle}><span style={{ fontWeight: "600" }}>{item.from_month}-{item.to_month}</span></td>
                <td style={tdStyle}>
                    <span style={{ fontSize: "12px", color: C.textMuted, fontVariantNumeric: "tabular-nums" }}>
                        {formatDateTime(item.run_date_time)}
                    </span>
                </td>
                <td style={tdStyle}><StatusBadge status={item.report_status} /></td>

                {/* Action cell — all icons preserved exactly */}
                <td style={{ ...tdStyle, textAlign: "center" }}>
                    <div style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>

                        {/* View */}
                        {!item.is_locked ? (
                            <Tooltip title="Click to view GST Computation Details">
                                <span style={{ display: "inline-flex" }}>
                                    <VisibilityOutlinedIcon
                                        className="action-icon-button showIcon"
                                        onClick={() => updatedShowDetails(item)}
                                        style={{ cursor: "pointer", fontSize: "20px" }}
                                        color="primary"
                                    />
                                </span>
                            </Tooltip>
                        ) : (
                            <Tooltip title="Please unlock the GST Computation Report to view details">
                                <span style={{ display: "inline-flex" }}>
                                    <VisibilityOutlinedIcon
                                        className="action-icon-button showIcon"
                                        onClick={() => handleSnackbarOpen("Please unlock the GST Computation Report to view details", "warning")}
                                        style={{ cursor: "pointer", fontSize: "20px" }}
                                        color="disabled"
                                    />
                                </span>
                            </Tooltip>
                        )}

                        {/* Lock / Unlock */}
                        {canWrite("GST COMPUTATION REPORT") && item.report_status === "Generated" && (
                            item.is_locked ? (
                                <Tooltip title="Unlock">
                                    <span style={{ display: "inline-flex" }}>
                                        <LockRoundedIcon
                                            className="action-icon-button showIcon"
                                            color="primary"
                                            style={{ cursor: "pointer", fontSize: "20px" }}
                                            onClick={() => handleLockToggle(item.id, item.is_locked)}
                                        />
                                    </span>
                                </Tooltip>
                            ) : (
                                <Tooltip title="Lock">
                                    <span style={{ display: "inline-flex" }}>
                                        <LockOpenOutlinedIcon
                                            className="action-icon-button showIcon"
                                            color="primary"
                                            style={{ cursor: "pointer", fontSize: "20px" }}
                                            onClick={() => handleLockToggle(item.id, item.is_locked)}
                                        />
                                    </span>
                                </Tooltip>
                            )
                        )}

                        {/* Excel export */}
                        {(item.is_exported_for_regeneration || item.is_invalid) && (
                            !item.excel_loading ? (
                                <Tooltip title="Export Excel">
                                    <span style={{ display: "inline-flex" }}>
                                        <img
                                            onClick={() => handleExportExcel(item)}
                                            style={{ height: "23px", width: "25px", cursor: "pointer" }}
                                            src={excelIconImage}
                                            alt="Excel"
                                        />
                                    </span>
                                </Tooltip>
                            ) : (
                                <CircularProgress size={18} style={{ color: "green" }} />
                            )
                        )}

                       {/* Regenerate */}
                        {canWrite("GST COMPUTATION REPORT") && item.report_status === "Generated" && item.is_report_generate && (
                            !item.is_locked ? (
                                item.regenerateLoading ? (
                                    <CircularProgress size={18} style={{ color: "green" }} />
                                ) : (
                                    <Tooltip title="Regenerate">
                                        <span style={{ display: "inline-flex" }}>
                                            <ReplayCircleFilledIcon
                                                onClick={() => regenerateGstComputationReport(item)}
                                                style={{ cursor: "pointer", fontSize: "20px" }}
                                                color="success"
                                            />
                                        </span>
                                    </Tooltip>
                                )
                            ) : (
                                <Tooltip title="Please unlock the GST Computation Report to regenerate">
                                    <span style={{ display: "inline-flex" }}>
                                        <ReplayCircleFilledIcon style={{ fontSize: "20px" }} color="disabled" />
                                    </span>
                                </Tooltip>
                            )
                        )}
                    </div>
                </td>
            </tr>
        ));
    };

    const totalCount     = tdsReconHistoryData ? tdsReconHistoryData.length : 0;
    const generatedCount = tdsReconHistoryData ? tdsReconHistoryData.filter((r) => r.report_status === "Generated").length : 0;
    const lockedCount    = tdsReconHistoryData ? tdsReconHistoryData.filter((r) => r.is_locked).length : 0;

    return (
        <React.Fragment>
            <style>{`
                @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.4} }
                @keyframes spin { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }
            `}</style>

            <div style={{ padding: "28px 32px", background: C.surface, fontFamily: "inherit" }}>

                {/* ── Page header ── */}
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: C.white, border: `1px solid ${C.border}`, borderRadius: "10px", padding: "16px 20px", marginBottom: "20px", boxShadow: "0 1px 3px rgba(13,33,55,0.06)" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
                        <button
                            onClick={handleBack}
                            title="Back to Reports"
                            style={{ width: "32px", height: "32px", borderRadius: "8px", border: `1px solid ${C.border}`, background: C.white, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: C.textSub, fontSize: "14px", flexShrink: 0 }}
                        >←</button>
                        <div style={{ width: "42px", height: "42px", borderRadius: "10px", background: C.accentLight, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                            <DocIcon />
                        </div>
                        <div>
                            <div style={{ fontSize: "23px", fontWeight: "700", color: C.text, lineHeight: 1.2 }}>GST Computation Report</div>
                            <div style={{ fontSize: "12px", color: C.textMuted, marginTop: "4px" }}>GST computation summary records</div>
                        </div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        {/* Refresh — reloads the table using the same getTdsPayableRecon() the page already calls on mount */}
                        <Tooltip title="Refresh">
                            <span style={{ display: "inline-flex" }}>
                                <button
                                    onClick={getTdsPayableRecon}
                                    disabled={loaderForTable}
                                    title="Refresh"
                                    style={{ width: "36px", height: "36px", borderRadius: "8px", border: `1px solid ${C.border}`, background: C.white, display: "flex", alignItems: "center", justifyContent: "center", cursor: loaderForTable ? "not-allowed" : "pointer", flexShrink: 0 }}
                                >
                                    <RefreshIcon
                                        style={{
                                            fontSize: "18px",
                                            color: C.textSub,
                                            animation: loaderForTable ? "spin 0.9s linear infinite" : "none",
                                        }}
                                    />
                                </button>
                            </span>
                        </Tooltip>
                        {triggerButton && canWrite("GST COMPUTATION REPORT") && (
                            <button
                                onClick={handleTDSREconciliationButtonEvent}
                                style={{ display: "flex", alignItems: "center", gap: "6px", padding: "0 18px", height: "36px", borderRadius: "8px", background: C.navy, color: C.white, border: "none", fontSize: "13px", fontWeight: "500", cursor: "pointer" }}
                            >
                                <span style={{ fontSize: "16px", lineHeight: 1 }}>+</span>
                                New GST Computation Report
                            </button>
                        )}
                    </div>
                </div>

                {/* ── Metrics cards ── */}
                {/* <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "14px", marginBottom: "20px" }}>
                    {[
                        { label: "Total Reports", value: totalCount,     borderColor: C.accent,  badge: totalCount > 0 },
                        { label: "Generated",     value: generatedCount, borderColor: "#28a55f", badge: false },
                        { label: "Locked",        value: lockedCount,    borderColor: "#8298b2", badge: false },
                    ].map(({ label, value, borderColor, badge }) => (
                        <div key={label} style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: "10px", padding: "16px 20px", boxShadow: "0 1px 3px rgba(13,33,55,0.05)", borderTop: `3px solid ${borderColor}` }}>
                            <div style={{ fontSize: "26px", fontWeight: "700", color: C.text, lineHeight: 1, letterSpacing: "-0.5px" }}>{value}</div>
                            <div style={{ fontSize: "11px", color: C.textMuted, marginTop: "5px", fontWeight: "500", textTransform: "uppercase", letterSpacing: "0.06em" }}>{label}</div>
                            {badge && <div style={{ display: "inline-block", marginTop: "8px", fontSize: "10px", padding: "2px 8px", borderRadius: "12px", background: C.success.bg, color: C.success.text, fontWeight: "600" }}>All generated</div>}
                        </div>
                    ))}
                </div> */}

                {/* ── Table card ── */}
                {tdsHistoryTable && (
                    <div style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: "10px", overflow: "hidden", boxShadow: "0 1px 3px rgba(13,33,55,0.05)" }}>
                        <div style={{ maxHeight: "480px", overflowY: "auto", overflowX: "hidden" }}>
                            <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
                                <colgroup>
                                    <col style={{ width: "16%" }} />
                                    <col style={{ width: "18%" }} />
                                    <col style={{ width: "28%" }} />
                                    <col style={{ width: "18%" }} />
                                    <col style={{ width: "20%" }} />
                                </colgroup>
                                <thead style={{ position: "sticky", top: 0, zIndex: 1 }}>
                                    <tr>
                                        <th style={thStyle}>Financial Year</th>
                                        <th style={thStyle}>Period</th>
                                        <th style={thStyle}>Run Date &amp; Time</th>
                                        <th style={thStyle}>Status</th>
                                        <th style={{ ...thStyle, textAlign: "center" }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>{renderTableBody()}</tbody>
                            </table>
                        </div>

                        {/* Footer */}
                        {!loaderForTable && tdsReconHistoryData && tdsReconHistoryData.length > 0 && (
                            <div style={{ padding: "10px 18px", borderTop: `1px solid ${C.borderLight}`, fontSize: "11px", color: C.textMuted, background: C.white }}>
                                Showing {tdsReconHistoryData.length} record{tdsReconHistoryData.length !== 1 ? "s" : ""}
                            </div>
                        )}
                    </div>
                )}
            </div>

           {/* ── Modal ── */}
            {canWrite("GST COMPUTATION REPORT") && <Modal size="lg" centered show={triggerModelFromToDate} onHide={handleOpenAndCloseModel}>
                <Modal.Header closeButton style={{ background: C.navy, borderBottom: "none", padding: "16px 22px" }}>
                    <Modal.Title style={{ fontSize: "18px", fontWeight: "600", color: "#ffffff" }}>
                        GST Computation Report
                    </Modal.Title>
                </Modal.Header>

                <ValidatorForm useRef="form" onSubmit={onSubmitHandlerForData} onError={(errors) => console.log(errors)}>
                    <Modal.Body style={{ padding: "22px 22px 10px" }}>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "16px", marginBottom: "16px" }}>

                            {/* Financial Year */}
                            <div>
                                <label style={labelStyle}>Financial Year <span style={{ color: "#e53e3e" }}>*</span></label>
                                <FormControl sx={{ minWidth: "100%" }}>
                                    <Select
                                        value={year}
                                        onChange={(e) => { setYear(e.target.value); setQuarter(""); setPeriod(null); setTrigarForErrorMessage(false); }}
                                        input={<BootstrapInput />}
                                    >
                                        {yearFromArr.map((v) => <MenuItem key={v.id} value={v.year}>{v.year}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </div>

                            {/* Quarter */}
                            <div>
                                <label style={labelStyle}>Quarter</label>
                                <FormControl sx={{ minWidth: "100%" }}>
                                    <Select
                                        value={quarter}
                                        onChange={(e) => setQuarter(e.target.value)}
                                        input={<BootstrapInput />}
                                    >
                                        {Quter.map((v) => <MenuItem key={v.id} value={v.id}>{v.value}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </div>

                            {/* Period */}
                            <div>
                                <label style={{ ...labelStyle, opacity: quarter === "" || quarter === null ? 0.5 : 1 }}>Period</label>
                                <FormControl sx={{ minWidth: "100%" }}>
                                    <Select
                                        value={period}
                                        disabled={quarter === "" || quarter === null ? true : false}
                                        onChange={(e) => setPeriod(e.target.value)}
                                        input={<BootstrapInput />}
                                    >
                                        {month.map((v) => {
                                            if (quarter === "quarter1") {
                                                if (["04","05","06"].includes(v.id)) return <MenuItem key={v.id} value={v.value}>{v.value}</MenuItem>;
                                            } else if (quarter === "quarter2") {
                                                if (["07","08","09"].includes(v.id)) return <MenuItem key={v.id} value={v.value}>{v.value}</MenuItem>;
                                            } else if (quarter === "quarter3") {
                                                if (["10","11","12"].includes(v.id)) return <MenuItem key={v.id} value={v.value}>{v.value}</MenuItem>;
                                            } else {
                                                if (["01","02","03"].includes(v.id)) return <MenuItem key={v.id} value={v.value}>{v.value}</MenuItem>;
                                            }
                                            return null;
                                        })}
                                    </Select>
                                </FormControl>
                            </div>
                        </div>

                        {trigarForErrorMessage && (
                            <div style={{ color: "#e53e3e", fontWeight: "600", fontSize: "13px", marginTop: "4px" }}>
                                {errorMessage}
                            </div>
                        )}
                    </Modal.Body>

                    <Modal.Footer style={{ padding: "12px 22px", gap: "8px", borderTop: `1px solid ${C.borderLight}` }}>
                        <button
                            type="button"
                            onClick={handleOpenAndCloseModel}
                            style={{ padding: "0 18px", height: "36px", borderRadius: "8px", border: `1px solid ${C.border}`, background: C.white, fontSize: "13px", color: C.textSub, cursor: "pointer" }}
                        >
                            Cancel
                        </button>
                        <LoadingButton
                            variant="contained"
                            loading={reportGennerationLoading}
                            type="submit"
                            disabled={!year || !quarter}
                            style={{ height: "36px", minWidth: "140px", borderRadius: "8px", background: C.navy, color: C.white, fontSize: "13px", fontWeight: "600", textTransform: "none", boxShadow: "none" }}
                        >
                            Submit
                        </LoadingButton>
                    </Modal.Footer>
               </ValidatorForm>
            </Modal>}

            {/* ── Snackbar ── */}
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                open={snackbarOpen}
                autoHideDuration={4500}
                onClose={handleSnackbarClose}
                style={{ maxWidth: "340px" }}
            >
                <MuiAlert elevation={6} variant="filled" onClose={handleSnackbarClose} severity={snackbarSeverity}>
                    {responseMessage}{message}
                </MuiAlert>
            </Snackbar>
        </React.Fragment>
    );
}